module.exports = __webpack_public_path__ + "static/step2-a99a406be225f440291107ccb2a6f47a.png";